<template>
  <div>
    <div class="flex items-center justify-center">
      <div
        v-for="(menu, index) in menus"
        :key="index"
        class="cursor-pointer flex justify-center items-center font-bold bg-default h-9 w-48 rounded-lg text-white mr-10 mt-6"
        :class="menuActive.id == menu.id ? 'gradient-background' : ''"
        @click="menuClick(menu)"
      >
        {{ menu.title }}
      </div>
    </div>
    <div class="p-6">
      <UserList v-if="menuActive && menuActive.name == 'User'" />
      <GroupList v-else-if="menuActive && menuActive.name == 'Group'" />
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import UserList from "@/views/user/UserList.vue";
import GroupList from "@/views/user/GroupList.vue";
import { mapActions, mapGetters } from "vuex";
import { ModuleUser } from "@/store/module-const";
import { Modal } from "ant-design-vue";
export default {
  name: "UserManager",
  components: {
    BaseList,
    UserList,
    GroupList,
  },
  data() {
    return {
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      menus: [],
      menuActive: {},
    };
  },
  computed: {},
  async created() {
    const me = this;
    me.initDataStatic();
  },
  methods: {
    ...mapActions(ModuleUser, ["getUsers", "updateUser", "deleteUser"]),

    initDataStatic() {
      const me = this;
      me.menus = [
        {
          id: 1,
          name: "User",
          router: "/user",
          title: me.$t("i18nCommon.UserInfo.User"),
          isActive: true,
        },
        {
          id: 2,
          name: "Group",
          router: "/group",
          title: me.$t("i18nCommon.UserInfo.Group"),
        },
        // {
        //   id: 3,
        //   name: "Roles",
        //   router: "/roles",
        //   title: me.$t("i18nCommon.UserInfo.Roles"),
        // },
      ];
      me.menuActive = me.menus[0];
    },
    menuClick(menu) {
      const me = this;
      me.menuActive = menu;
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-default {
  background: #e5e5e5;
  color: #000;
}

.gradient-background {
  background: #1677ff;
    color: #fff;

  &:hover {
    background: #0e61d6;
  }
}
</style>
